import { render, staticRenderFns } from "./Osa005.vue?vue&type=template&id=2d1c7700&scoped=true"
var script = {}
import style0 from "./Osa005.vue?vue&type=style&index=0&id=2d1c7700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1c7700",
  null
  
)

export default component.exports